import { Grid } from '@material-ui/core';
import React from 'react';
import { addressToString } from 'internal/business/maps/distances';
import { Colors, Text } from 'library';
import { Link } from 'react-router-dom';
import { IBusinessLocation } from 'models';

export default function BusinessLocationCard({ businessLocation }: { businessLocation: IBusinessLocation }) {
    return (
        <Grid
            item
            container
            direction="row"
            style={{
                marginBottom: 10,
                padding: 20,
                backgroundColor: Colors.white,
                borderRadius: 18,
                boxShadow: '0px 3px 6px 0px #00000029',
            }}
            justify="space-between"
            xs={12}
        >
            <Grid item container direction="column" xs={12} md={9} style={{ maxHeight: 200 }}>
                <Text bold>{businessLocation.name}</Text>
                <Text>{addressToString(businessLocation.address)}</Text>
                {businessLocation.business_contacts.length ? (
                    <Text variant="caption">
                        <Text bold inline variant="caption">
                            Additional Contacts:
                        </Text>{' '}
                        {businessLocation.business_contacts
                            .map((c: any) => `${c.user.first_name} ${c.user.last_name[0]}`)
                            .join(', ')}
                    </Text>
                ) : null}
            </Grid>
            <Link
                to={`/profile/locations/${businessLocation.id}`}
                style={{ color: Colors.darkNavy, textDecorationLine: 'underline', fontSize: 16 }}
            >
                Edit
            </Link>
        </Grid>
    );
}
